import { makeAutoObservable } from "mobx";

class AuthorizationStore {
  isLoggedIn: boolean = true;
  isLoggedOutModalOn: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoggedIn(value: boolean) {
    this.isLoggedIn = value;
  }

  setIsLoggedOutModalOn(value: boolean) {
    this.isLoggedOutModalOn = value;
  }
}

export const auth = new AuthorizationStore();
